var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2126 2.15527V4.67618C16.2126 5.52093 15.3915 6.20812 14.3818 6.20812C13.372 6.20812 12.5522 5.52093 12.5522 4.67618V2.15527H7.44785V4.67618C7.44785 5.52093 6.62676 6.20812 5.61824 6.20812C4.60971 6.20812 3.78741 5.52093 3.78741 4.67618V2.15527H0V20.0004H20V2.15527H16.2126ZM18.4316 17.9546H1.5672V7.47826H18.4316V17.9546V17.9546Z",
    fill: "#72767C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69206 5.39813H5.54332C5.1092 5.39813 4.75488 5.04302 4.75488 4.60793V0.790207C4.75488 0.355108 5.1092 0 5.54332 0H5.69206C6.12619 0 6.4805 0.355108 6.4805 0.790207V4.60671C6.4805 5.04181 6.12619 5.39813 5.69206 5.39813Z",
    fill: "#72767C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4567 5.39813H14.308C13.8738 5.39813 13.5195 5.04302 13.5195 4.60793V0.790207C13.5195 0.355108 13.8738 0 14.308 0H14.4567C14.8908 0 15.2451 0.355108 15.2451 0.790207V4.60671C15.2451 5.04181 14.8896 5.39813 14.4567 5.39813Z",
    fill: "#72767C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93393 16.3483C7.66184 16.3483 7.39338 16.2344 7.20232 16.0138L4.56855 12.9645C4.21907 12.5597 4.2626 11.9476 4.6665 11.5961C5.07039 11.2459 5.68107 11.2895 6.03175 11.6943L8.06211 14.0455L14.1036 9.29097C14.5244 8.9601 15.1315 9.03403 15.4616 9.45459C15.7917 9.87514 15.718 10.4848 15.2983 10.8156L8.5313 16.141C8.35475 16.2804 8.14313 16.3483 7.93393 16.3483Z",
    fill: "#72767C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/DatePicker_icon.206117bcbe42bd68756c79f08316bad7.svg";
export { ForwardRef as ReactComponent };